( function () {
	'use strict';
	/* eslint-disable max-params */
	function signatureModalCtrl ( $modalInstance, obs, submitFn, session, obsService, apiService, logger, parentController, submitStatus ) {
		/* eslint-enable max-params */
		var self   = this;
		var userId = session.getCredentials().PersonnelId;

		self.isSelfObs  = obs.observer.id === obs.observee.id;
		self.isObserver = userId === obs.observer.id;
		self.isObservee = userId === obs.observee.id;

		function generateSignatureObj () {
			return {
				'id'      : apiService.generateUUID(),
				'userId'  : userId,
				'sign'    : self.signature,
				'date'    : new Date().valueOf(),
				'isValid' : true
			};
		}

		function attachSig ( sig ) {
			var role = Object.keys( sig )[ 0 ];

			obs.digitalSignature[ role ].push( sig[ role ] );
		}

		function updateSingleSig ( sig, cb ) {
			function setFlag () {
				parentController.isSavingSig      = false;
				parentController.signatureSuccess = true;
			}

			function closeModal () {
				$modalInstance.close();
				cb( sig );
			}

			parentController.isSavingSig = true;

			apiService
				.signature
				.update( obs.id, sig )
				.then( closeModal, logger.notifyError )
				.finally( setFlag );
		}

		function submitObs ( sig ) {
			attachSig( sig );
			submitFn( submitStatus === 'complete' );
		}

		function asObserver () {
			var hasSig = Boolean( obs.digitalSignature ) && submitStatus !== 'complete';
			var sig    = generateSignatureObj();

			obs.digitalSignature = obs.digitalSignature || { 'observer' : [] };

			var isSelfObs     = Number( self.isSelfObs );
			var submitMethods = [ submitObs, updateSingleSig ];
			var observeeSig   = [ obs.digitalSignature.observee || [], [ sig ] ];

			var pdData = [ {
				'id'           : obs.id,
				'resourceId'   : obs.id,
				'pdOwner'      : obs.observee.id,
				'type'         : 4,
				'assignedDate' : new Date()
			}, {
				'id'            : obs.id,
				'resourceId'    : obs.id,
				'pdOwner'       : obs.observee.id,
				'type'          : 4,
				'completedDate' : new Date(),
				'assignedDate'  : new Date()
			} ];

			function checkObserveePD ( item ) {
				return item.pdOwner === obs.observee.id || !item.pdOwner;
			}

			parentController.hasSigned    = true;
			obs.digitalSignature.observee = observeeSig[ isSelfObs ];
			obs.masterPrescribedResources = obs.masterPrescribedResources || [];

			var hasObserveePD = obs.masterPrescribedResources.some( checkObserveePD );

			obs.masterPrescribedResources = [ obs.masterPrescribedResources.concat( pdData[ isSelfObs ] ), obs.masterPrescribedResources ][ Number( hasObserveePD ) ];

			submitMethods[ Number( hasSig ) ]( { 'observer' : sig }, submitObs );
		}

		function asObservee () {
			var signature = {};
			var roles     = [ 'reviewers', 'observee' ];
			var role      = roles[ Number( self.isObservee ) ];

			signature[ role ] = generateSignatureObj();

			function attachSigToObs () {
				obs.digitalSignature[ role ] = signature;
				parentController.hasSigned   = true;
			}

			updateSingleSig( signature, attachSigToObs );
		}

		function submit () {
			var methods = [ asObservee, asObserver ];

			methods[ Number( self.isObserver ) ]( submitStatus );
			$modalInstance.close();
		}

		self.obs        = obs;
		self.close      = $modalInstance.dismiss;
		self.callSubmit = submit;
	}

	angular
		.module( 'app.observations' )
		.controller( 'signatureModalCtrl', signatureModalCtrl );

	signatureModalCtrl.$inject = [ '$modalInstance', 'obs', 'submitFn', 'Session', 'observationService', 'apiService', 'logger', 'parentController', 'submitStatus' ];
} )();
